import { render } from "./index.vue?vue&type=template&id=46f8e630&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=46f8e630&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-46f8e630"

export default script